// --- Core ---
import {get, set} from "local-storage";
import {Dispatch, SetStateAction, useEffect, useState} from "react";

/**
 * drop-in replacement for useState, but with persistence in local storage.
 *
 * Only persists if a local storage key is given
 */
const usePersistedState = <T>(initialValue: T, lsKey: string): [T, Dispatch<SetStateAction<T>>] => {
  const [state, setState] = useState(lsKey ? get<T>(lsKey) || initialValue : initialValue);

  useEffect(() => {
    if (lsKey) {
      set<T>(lsKey, state);
    }
  }, [state, lsKey]);

  return [state, setState];
};

export {
  usePersistedState
};
